import { tv } from '~/utils/tv'

export const SnackbarFooterButtonVariants = tv({
  base: `
    flex pl-twelvepulse pr-fourpulse pt-twopulse
  `,
})
export const SnackbarFooterLinkVariants = tv({
  base: `
    flex pl-eightpulse pr-fourpulse pt-twopulse
  `,
})
